import { apiConfig, client } from '@/api';
import { DataReviewApi } from '@/api/generated/MNT/apis/data-review-api';
import { config } from '@/config';

export const dataReviewApi = new DataReviewApi(apiConfig, config.API_URL, client);
